import Vue from "vue"
import VueRouter from "vue-router"
import Inicial from "./modulos/inicial"
import Cursos from "./modulos/cursos"
import Tabelas from "./modulos/tabelas"
import Estrutura from "./modulos/estrutura"
import Calendario from "./calendario"
import _autenticacao from "@universidade-franciscana/componente-front/src/utils/autenticacao.js"
import _servicos from "@universidade-franciscana/componente-front/src/enums/servicos.js"


Vue.use(VueRouter)

const TITULO_PADRAO = "UFN - Universidade Franciscana"

/**
 * Importa os arrays das rotas com spread operator
 */
const routes = [
  ...Calendario,
	...Inicial,
	{
        path: "*",
        name: "erro404",
        component: () => import("@universidade-franciscana/componente-front/src/components/comuns/erros/404.vue"),
        meta: {
            title: "Página Não Encontrada",
        },
  },
  ...Cursos, {
        path: "*",
        name: "erro404",
        component: () => import("@universidade-franciscana/componente-front/src/components/comuns/erros/404.vue"),
        meta: {
            title: "Página Não Encontrada",
        },
  },


  ...Tabelas,{
    path: "*",
        name: "erro404",
        component: () => import("@universidade-franciscana/componente-front/src/components/comuns/erros/404.vue"),
        meta: {
            title: "Página Não Encontrada",
        },
  },
  ...Estrutura, {
    path: "*",
        name: "erro404",
        component: () => import("@universidade-franciscana/componente-front/src/components/comuns/erros/404.vue"),
        meta: {
            title: "Página Não Encontrada",
        },
  },
  {
     path: "/tabela1",
    name: "tabela1",
    component: () => import("@/view/tabela/Tabela.vue"),
    meta: {
      titulo: "Tabela",
      caminho:"tabelas",
      breadcrumb: [
        { text: "Tabela", disabled: false, to: "/" },
      ],
    },
  },
]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) => {
    /**
     * Seta o nome no título da página
     */
    Vue.nextTick(() => {
        document.title = to.meta.title || TITULO_PADRAO
    })

    next()

    if (
    to.meta.caminho !== undefined &&
    to.path !== "/erro403" &&
    to.path !== "/erro404" &&
    to.path !== "/erro500" &&
    !_autenticacao.permissao(to.meta.caminho, to.meta.tipoPermissao, _servicos.ACADEMICO)
  ) {
    next("/erro403")
  } else {
    next()
  }
})

export default router